<template>
  <div class="background">
    <v-container>
      <v-row v-if="screenplay">
        <v-col cols="12">
          <v-card>
            <v-card-text>
              <div class="text-center">{{screenplay.id}}</div>
              <v-item-group multiple>
                <v-item class="mb-2" v-slot:default="{}">
                  <v-card
                    class="d-flex pa-3"
                    @click="showNameEditPrompt"
                  >
                    <div class="title text--primary" v-text="screenplay.name" />
                  </v-card>
                </v-item>
                <v-item v-slot:default="{}">
                  <v-card
                    class="d-flex pa-3"
                    min-height="100"
                    max-height="200"
                    @click="showDescriptionEditPrompt"
                  >
                    <div class="auto-break auto-scroll w-100" v-text="screenplay.description" />
                  </v-card>
                </v-item>
              </v-item-group>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
      <v-row v-if="screenplay">
        <v-col cols="12">
          <v-card>
            <v-card-text>
              <v-list>
                <template v-for="scene in screenplay.scenes">
                  <v-list-item
                    :key="scene.id"
                    @click="$router.push(`/edit/scene?sid=${screenplay.id}&scene=${scene.id}`)"
                  >
                    <v-list-item-content>
                      <v-list-item-title class="d-flex align-center justify-space-between">
                        <span>
                          {{scene.id}}
                        </span>
                        <v-divider class="ml-4 mr-4"></v-divider>
                        <span>
                          <v-btn class="mr-3" icon href="javascript:;">
                            <v-icon>
                              mdi-pencil-outline
                            </v-icon>
                          </v-btn>
                          <v-btn
                            icon
                            :disabled="scene.id === 'START'"
                            @click.stop="showDeleteSceneConfirm(scene.id)"
                          >
                            <v-icon>
                              mdi-delete
                            </v-icon>
                          </v-btn>
                        </span>
                      </v-list-item-title>
                    </v-list-item-content>
                  </v-list-item>
                </template>
                <v-list-item @click="showAddScenePrompt()">
                  <v-list-item-content>
                    <v-list-item-title>
                      <div class="text-center">
                        <v-icon>
                          mdi-plus
                        </v-icon>
                      </div>
                    </v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
              </v-list>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12">
          <v-card>
            <v-card-title>
              Playbacks
            </v-card-title>
            <v-data-table
              :loading="recordTable.loading"
              :headers="recordTable.headers"
              :items="recordTable.records"
              @click:row="onDataTableRowClick"
            >
              <template v-slot:item.index="{ item }">
                <span>{{item.index}}</span>
              </template>
              <template v-slot:item.show="{ item }">
                <span>
                  <v-btn @click="$router.push(`/screenplay/history/${item.id}`)">檢視</v-btn>
                </span>
              </template>
            </v-data-table>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
    <simple-prompt ref="prompt"/>
  </div>
</template>

<script>
import _ from 'lodash'
import * as util from '@/lib/util'
import * as gameLoader from '@/lib/loader'
import Screenplay from '@/lib/Screenplay'
import Message from '@/lib/Message'
import Scene from '@/lib/Scene'
import * as SimplePrompt from '@/components/SimplePrompt'
import axios from '@/lib/axios'

export default {
  name: 'screenplay-editor',
  components: {
    SimplePrompt: SimplePrompt.default
  },
  computed: {
    user(){
      return this.$store.state.user.profile
    }
  },
  watch: {
  },
  data: ()=>{
    return {
      screenplay: null,
      recordTable: {
        loading: true,
        records: [],
        headers: [
          { text: '#', value: 'index' },
          { text: '用戶', value: 'uid' },
          { text: '日期', value: 'created_at' },
          { text: '', value: 'show' }
        ]
      }
    }
  },
  mounted(){
    this.$store.commit(
      'appbar/setOptions',
      [
        {
          key: 'show-trial-game',
          text: 'play game'
        }
      ]
    )
    this.$appbarCallback = this.appbarCallback.bind(this)
    this.$bus.$on('appbar-option-click', this.$appbarCallback)
    this.$nextTick(()=>{
      this.$prompt = this.$refs.prompt.prompt
    })
    util.delay(200)
      .then(()=>gameLoader.loadScreenplay(this.$route.query.sid || 'test'))
      .catch((e)=>{
        // if(this.$dev){
        let screenplay = Screenplay.generateDefaultScreenplay({
          id: this.$route.query.sid
        })
        gameLoader.saveScreenplay(screenplay)
        return screenplay
        // }else{
        //   throw `new `Error(e)
        // }
      })
      .then((screenplay)=>{
        if(screenplay.author){
          // if(this.user.id !== screenplay.author){
          //   throw new Error('no permission')
          // }
        }
        this.screenplay = screenplay
        console.log('screenplay', screenplay)
        return gameLoader.loadGameRecord({ screenplayId: screenplay.id, withoutData: true })
      })
      .then((records)=>{
        records.sort((a, b)=>{
          return new Date(b.created_at) - new Date(a.created_at)
        })
        records.forEach((item, i)=>item.index = i + 1)
        this.recordTable.loading = false
        this.recordTable.records = records
      })
      .catch((e)=>{
        console.error(e)
      })
  },
  beforeDestroy(){
    this.$bus.$off('appbar-option-click', this.$appbarCallback)
  },
  methods: {
    appbarCallback(btn, event){
      console.log('appbarCallback', btn)
      if(btn.key === 'show-trial-game'){
        if(this.screenplay){
          this.$router.push(`/game/dev?sid=${this.screenplay.id}`)
        }
      }
    },
    log(){
      console.log.apply(console, arguments)
    },
    showDeleteSceneConfirm(sceneId){
      let check = window.confirm('Are you sure want to delete this scene?')
      if(check){
        let i = this.screenplay.scenes.findIndex((scene)=>{
          return scene.id === sceneId
        })
        if(i !== -1){
          this.screenplay.scenes.splice(i, 1)
          gameLoader.deleteScene(this.screenplay.id, sceneId)
        }
      }
    },
    showNameEditPrompt(){
      return this.$prompt({
        label: 'please input screenplay name',
        default: this.screenplay.name,
        autoClose: false,
        rules: [
          (input)=>{
            return (input && input.length !== 0) || '*require'
          },
          (input)=>{
            return input.length < 30 || 'length limit: 30'
          }
        ],
        hint: 'length limit: 30',
        onButtonClick: (result, cb)=>{
          console.log('test', result, cb)
          if(result.type === 'input-value'){
            if(result.input){
              cb.lock()
              let tmp = this.screenplay.name
              this.screenplay.name = result.input
              gameLoader.updateScreenplay(this.screenplay)
                .then(()=>{
                  cb.close()
                })
                .catch((e)=>{
                  this.screenplay.name = tmp
                  cb.unlock()
                  cb.error('faild to upload')
                  console.error(e)
                })
            }
          }
        }
      })
    },
    showDescriptionEditPrompt(){
      return this.$prompt({
        label: 'please input description',
        default: this.screenplay.description,
        multiline: true,
        autoClose: false,
        rules: [
          (input)=>{
            return (input && input.length !== 0) || '*require'
          },
          (input)=>{
            return input.length < 300 || 'length limit: 300'
          }
        ],
        hint: 'length limit: 300',
        onButtonClick: (result, cb)=>{
          console.log('test', result, cb)
          if(result.type === 'input-value'){
            if(result.input){
              cb.lock()
              let tmp = this.screenplay.description
              this.screenplay.description = result.input
              gameLoader.updateScreenplay(this.screenplay)
                .then(()=>{
                  cb.close()
                })
                .catch((e)=>{
                  this.screenplay.description = tmp
                  cb.unlock()
                  cb.error('faild to upload')
                  console.error(e)
                })
            }
          }
        }
      })
    },
    showAddScenePrompt(){
      return this.$prompt({
        label: 'please input scene id',
        default: '',
        rules: [
          (input)=>{
            return (input && input.length !== 0) || '*require'
          },
          (input)=>{
            return input.length < 30 || 'length limit: 30'
          },
          (input)=>{
            return !input.match(/\s|\//) || 'invalid character'
          },
          (input)=>{
            let id = input
            let s = this.screenplay.scenes.find((scene)=>{
              return scene.id === id
            })
            return !s || 'scene id duplicate'
          }
        ],
        hint: 'length limit: 30',
        autoClose: false,
        onButtonClick: (result, cb)=>{
          console.log('test', result, cb)
          if(result.type === 'input-value'){
            if(result.input){
              cb.lock()
              let scene = Scene.generate({
                id: result.input
              })
              let msg = scene.messages[0]
              msg.sender = 'Ace'
              msg.content = 'hello'
              gameLoader.saveScene(this.screenplay.id, scene)
                .then(()=>{
                  cb.close()
                  this.screenplay.scenes.push(scene)
                  // throw new Error()
                })
                .catch((e)=>{
                  cb.unlock()
                  cb.error('faild to upload')
                  console.error(e)
                })
            }
          }
        }
      })
    }
    // onDataTableRowClick(item){
    //   // this.$router.push(`/screenplay/history/${item.id}`)
    // }
  }
}
</script>
<style>
  .background{
    width: 100vw;
    height: 100%;
    overflow-y: scroll;
    background-color: #15202b;
    color: white;
  }
  .w-100{
    width: 100%;
  }
  .auto-break{
    word-wrap: break-word;      /* IE 5.5-7 */
    white-space: -moz-pre-wrap; /* Firefox 1.0-2.0 */
    white-space: pre-wrap;      /* current browsers */
  }
  .auto-scroll{
    overflow-y: auto;
  }
</style>
